export default {
    data() {
        return {
            palette: [
                '#1f314e',
                '#2d4774',
                '#37558b',
                '#4164a6',
                '#597dc0',
                '#6c8cc8',
                '#7e9acf',
                '#a0b6de',
                '#b4c4e4',
                '#d9e2f2',
            ],
        };
    },
    computed: {
        partnerShares() {
            return _.mapValues(this.partners, partner => parseFloat(partner.share_percent));
        },
        partnerMinShare() {
            if (!_.isEmpty(this.partnerShares)) {
                const shares = Object.values(this.partnerShares);
                // remove round if needed
                return Math.min.apply(null, shares);
            }

            return 0;
        },
        partnerMaxShare() {
            if (!_.isEmpty(this.partnerShares)) {
                const shares = Object.values(this.partnerShares);

                return Math.max.apply(null, shares);
            }

            return 0;
        },
        sharePercentSum() {
            const percent = Object.values(this.partnerShares).reduce((a, b) => a + b, 0);

            return Math.round((percent + Number.EPSILON) * 100) / 100;
        },
        sharePercentRemaining() {
            return Math.round(((100 - this.sharePercentSum) + Number.EPSILON) * 100) / 100;
        },
        partnerColors() {
            const colors = {};

            _.forEach(this.partnerIds, (partnerId, id) => {
                colors[partnerId] = this.palette[id];
            });

            return colors;
        },
        sharesChartData() {
            if (this.sharePercentSum === 0) {
                return {
                    datasets: [{
                        data: [100],
                        backgroundColor: ['rgba(38, 60, 97, 0.1)'],
                        label: 'Shares'
                    }],
                    labels: ['None'],
                }
            }

            return {
                datasets: [{
                    data: Object.values(this.partnerShares),
                    backgroundColor: this.palette,
                    label: 'Shares'
                }],
                labels: Object.values(this.partnerNames),
            }
        },
    },
    watch: {
    //     partnerMinShare(share) {
    //         if (share > this.company.call_assembly_percent) {
    //             this.company.call_assembly_percent = parseFloat(share);
    //         }
    //     },
        partnerShares(shares) {
            this.obligations.special_sales.forEach((obligation) => {
                obligation.share_percent = shares[obligation.partner] - 1;
            });
        }
    }
};
